import { PhasedReleaseChartBase, PhasedReleaseDaysSummary } from '@/components/appHome/widgets/LiveReleaseChartWidget';
import { colorForPhasedState } from '@/components/monitoring/PhasedReleaseCard';
import { appHomeCardsWidgetTitleStyle } from '@/components/styles/globalStyles';
import { isPhasedReleasePaused } from '@/helpers';
import { displayTextForPhasedReleaseState } from '@/helpers/displayHelpers';
import { PhasedRelease } from '@/types';
import Text from 'antd/lib/typography/Text';
import * as React from 'react';

export interface PhasedReleaseInlineChartProps {
    phasedRelease: PhasedRelease;
    daysToPercent: number[];
    wasAccelerated: boolean;
    wasHalted: boolean;
    isAutomatedPhasedRollout: boolean;
}

export const PhasedReleaseInlineChart: React.FC<PhasedReleaseInlineChartProps> = ({
    phasedRelease,
    daysToPercent,
    wasAccelerated,
    wasHalted,
    isAutomatedPhasedRollout,
}) => {
    const statusColor = colorForPhasedState(phasedRelease?.state);

    const statusString = displayTextForPhasedReleaseState(
        phasedRelease?.state,
        phasedRelease?.isManuallyAcceleratedPhasedRollout,
        phasedRelease?.isRunwayAcceleratedRollout,
        phasedRelease?.isRunwayPaused,
    );

    return (
        <div
            style={{
                display: 'flex',
                gap: 18,
                width: 550,
                alignItems: 'center',
            }}
        >
            {(wasAccelerated || wasHalted) && (
                <Text
                    style={{
                        ...appHomeCardsWidgetTitleStyle,
                        color: statusColor,
                        flexShrink: 0,
                    }}
                    ellipsis
                >
                    {statusString}
                </Text>
            )}
            {phasedRelease && (
                <>
                    <PhasedReleaseDaysSummary
                        percentage={phasedRelease.phasedReleasePercent}
                        dayNumber={phasedRelease.dayNumber}
                        daysToPercent={daysToPercent}
                        isAutomatedPhasedRollout={isAutomatedPhasedRollout}
                        isRunwayAcceleratedRollout={phasedRelease.isManuallyAcceleratedPhasedRollout}
                        isRunwayRolloutPaused={phasedRelease.isRunwayPaused}
                    />

                    <PhasedReleaseChartBase
                        percentage={phasedRelease.phasedReleasePercent}
                        dayNumber={phasedRelease.dayNumber}
                        daysToPercent={daysToPercent}
                        isAutomatedPhasedRollout={isAutomatedPhasedRollout}
                        wasHalted={isPhasedReleasePaused(phasedRelease.state)}
                        wasAccelerated={
                            phasedRelease.isManuallyAcceleratedPhasedRollout || phasedRelease.isRunwayAcceleratedRollout
                        }
                    />
                </>
            )}
        </div>
    );
};
